import { createTrackingUtils } from "../index.js";
export const trackSwitchToRebookStore = createTrackingUtils({
    name: "flights_web_pbem_switch_to_rebook_store",
    defaultStage: 1,
    stages: {
        AFFECTED_USERS: 1
    },
    goals: {},
    goalsWithValue: ["rebook_page_render"]
});
